module.exports = __webpack_public_path__ + "img/wx.a9440f46.jpg";